export default __webpack_public_path__ + "static/media/Delete_Icon_popup.3d7d076c.svg";